<template src="../templates/product-item.html"></template>

<script>
export default {
  name: 'ProductItem',
  props: {
    product: {
      type: Object,
      default: () => null,
    },
    value: {
      type: [Number, null],
      default: () => 0,
    },
    promoIsOn: {
      type: Boolean,
      default: () => false,
    }
  },
  emits: ['set-value'],
  computed: {
    productUrl() {
      return `/spora/${this.product.link}`;
    },
    labelClass() {
      return `class-${this.product.class}`;
    },
    price() {
      if (this.promoIsOn) {
        return this.$filters.currencyFormatted(400);
      }

      return this.$filters.currencyFormatted(this.product.price);
    },
    priceDiscount() {
      if (this.promoIsOn) {
        return this.$filters.currencyFormatted(this.product.price);
      }

      if (!this.product.price_discount) {
        return null;
      }

      return this.$filters.currencyFormatted(this.product.price_discount);
    },
    isNew() {
      return Number(this.product.is_new) === 1;
    },
  },
  methods: {
    inputHandler(e) {
      this.$emit('set-value', Number(e.target.value));
      this.$forceUpdate();
    },
  },
};
</script>
